// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root__ZvIUa {
  display: flex;
  flex-direction: row;
}
.withBorder__IvgGy,
.withBackground__ZJ8rB {
  border-radius: var(--borderRadiusMedium);
  padding: 8px 12px;

  @media (min-width: 768px) {
    padding: 12px 16px;
  }
}
.withBorder__IvgGy {
  border: 1px solid;
}
.borderInformation__s3Io0 {
  border-color: var(--colorInformation);
}
.borderAttention__s38gI {
  border-color: var(--colorAttention);
}
.borderHelp__uXtZp {
  border-color: var(--colorInformation);
}
.borderSuccess__JPzF9 {
  border-color: var(--colorSuccess);
}
.backgroundInformation__CV9Rq {
  background-color: var(--colorInformationLight);

  & > svg {
    color: var(--colorInformation);
  }
}
.backgroundAttention__ViwbR {
  background-color: var(--colorAttentionLight);

  & > svg {
    color: var(--colorAttention);
  }
}
.backgroundHelp__kch7b {
  background-color: var(--colorInformationLight);

  & > svg {
    color: var(--colorInformation);
  }
}
.backgroundSuccess__UbF0z {
  background-color: var(--colorSuccessLight);

  & > svg {
    color: var(--colorSuccess);
  }
}
.icon__GznBP {
  flex-shrink: 0;

  margin: 0 0 0 8px;
}
.textWrapper__TGJwF {
  display: flex;
  flex-direction: column;

  width: 100%;
}
.img__m4UBU {
  margin-bottom: 16px;
  border-radius: var(--borderRadius);

  max-width: 100%;
  height: auto;
}
.title__H1jQB {

  margin: 0 0 8px;
  padding: 0;

  font-weight: var(--fontWeightSemiBold);
}
.text__EQcza {

  white-space: pre-line;
}
`, "",{"version":3,"sources":["webpack://./src/components/InfoBox/InfoBox.module.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AAEA;;EAEE,wCAAwC;EACxC,iBAAiB;;EAEjB;IACE,kBAAkB;EACpB;AACF;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,qCAAqC;AACvC;AAEA;EACE,mCAAmC;AACrC;AAEA;EACE,qCAAqC;AACvC;AAEA;EACE,iCAAiC;AACnC;AAEA;EACE,8CAA8C;;EAE9C;IACE,8BAA8B;EAChC;AACF;AAEA;EACE,4CAA4C;;EAE5C;IACE,4BAA4B;EAC9B;AACF;AAEA;EACE,8CAA8C;;EAE9C;IACE,8BAA8B;EAChC;AACF;AAEA;EACE,0CAA0C;;EAE1C;IACE,0BAA0B;EAC5B;AACF;AAEA;EACE,cAAc;;EAEd,iBAAiB;AACnB;AAEA;EACE,aAAa;EACb,sBAAsB;;EAEtB,WAAW;AACb;AAEA;EACE,mBAAmB;EACnB,kCAAkC;;EAElC,eAAe;EACf,YAAY;AACd;AAEA;;EAGE,eAAe;EACf,UAAU;;EAEV,sCAAsC;AACxC;AAEA;;EAGE,qBAAqB;AACvB","sourcesContent":["@import '../../styles/customMediaQueries.css';\n\n.root {\n  display: flex;\n  flex-direction: row;\n}\n\n.withBorder,\n.withBackground {\n  border-radius: var(--borderRadiusMedium);\n  padding: 8px 12px;\n\n  @media (--viewportMedium) {\n    padding: 12px 16px;\n  }\n}\n\n.withBorder {\n  border: 1px solid;\n}\n\n.borderInformation {\n  border-color: var(--colorInformation);\n}\n\n.borderAttention {\n  border-color: var(--colorAttention);\n}\n\n.borderHelp {\n  border-color: var(--colorInformation);\n}\n\n.borderSuccess {\n  border-color: var(--colorSuccess);\n}\n\n.backgroundInformation {\n  background-color: var(--colorInformationLight);\n\n  & > svg {\n    color: var(--colorInformation);\n  }\n}\n\n.backgroundAttention {\n  background-color: var(--colorAttentionLight);\n\n  & > svg {\n    color: var(--colorAttention);\n  }\n}\n\n.backgroundHelp {\n  background-color: var(--colorInformationLight);\n\n  & > svg {\n    color: var(--colorInformation);\n  }\n}\n\n.backgroundSuccess {\n  background-color: var(--colorSuccessLight);\n\n  & > svg {\n    color: var(--colorSuccess);\n  }\n}\n\n.icon {\n  flex-shrink: 0;\n\n  margin: 0 0 0 8px;\n}\n\n.textWrapper {\n  display: flex;\n  flex-direction: column;\n\n  width: 100%;\n}\n\n.img {\n  margin-bottom: 16px;\n  border-radius: var(--borderRadius);\n\n  max-width: 100%;\n  height: auto;\n}\n\n.title {\n  composes: p from global;\n\n  margin: 0 0 8px;\n  padding: 0;\n\n  font-weight: var(--fontWeightSemiBold);\n}\n\n.text {\n  composes: marketplaceSmallFontStyles from global;\n\n  white-space: pre-line;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `root__ZvIUa`,
	"withBorder": `withBorder__IvgGy`,
	"withBackground": `withBackground__ZJ8rB`,
	"borderInformation": `borderInformation__s3Io0`,
	"borderAttention": `borderAttention__s38gI`,
	"borderHelp": `borderHelp__uXtZp`,
	"borderSuccess": `borderSuccess__JPzF9`,
	"backgroundInformation": `backgroundInformation__CV9Rq`,
	"backgroundAttention": `backgroundAttention__ViwbR`,
	"backgroundHelp": `backgroundHelp__kch7b`,
	"backgroundSuccess": `backgroundSuccess__UbF0z`,
	"icon": `icon__GznBP`,
	"textWrapper": `textWrapper__TGJwF`,
	"img": `img__m4UBU`,
	"title": `title__H1jQB p`,
	"text": `text__EQcza marketplaceSmallFontStyles`
};
export default ___CSS_LOADER_EXPORT___;
